var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurrencyDollarCircle = function SvgCurrencyDollarCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 1.5,
    height: 16,
    width: 16,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.3462C12.0576 15.3462 15.3469 12.0569 15.3469 7.99928C15.3469 3.94168 12.0576 0.652344 8 0.652344C3.9424 0.652344 0.653061 3.94168 0.653061 7.99928C0.653061 12.0569 3.9424 15.3462 8 15.3462Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95918 5.06026H7.20979C7.05303 5.04742 6.89534 5.06884 6.74769 5.12305C6.60003 5.17725 6.46594 5.26294 6.35471 5.37416C6.24349 5.48538 6.1578 5.61948 6.1036 5.76713C6.04939 5.91479 6.02797 6.07247 6.04081 6.22924C6.04081 7.53536 9.95918 8.48883 9.95918 9.76883C9.96183 9.92308 9.93341 10.0763 9.8756 10.2193C9.81779 10.3623 9.73179 10.4923 9.6227 10.6013C9.51362 10.7104 9.38369 10.7964 9.24067 10.8542C9.09764 10.912 8.94444 10.9405 8.7902 10.9378H6.04081",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.06118V3.5918",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.4088V10.9395",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurrencyDollarCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "currency-dollar-circle.df44b25816a5359616aa8c8d908d27a3.svg";